import '../scss/app.scss';

const $ = jQuery;

// Gallery
$(document).ready(function() {
	$('.story-gallery a').featherlightGallery({
		previousIcon: '«',
		nextIcon: '»',
		galleryFadeIn: 300,
		openSpeed: 300
	});
	$('.featured-work-slider-nav').each(function() {
		$(this).find('a').featherlightGallery({
			previousIcon: '«',
			nextIcon: '»',
			galleryFadeIn: 300,
			openSpeed: 300
		});
	});
});

// Featured Slider
$(document).ready(function() {
	$('.section-featured-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					arrows: false
				}
			}
		]
	});
});

// Featured Work Slider
$(document).ready(function() {
	$('.featured-work-slider-wrapper').each(function() {
		const gid = $(this).data('gid');
		$('.featured-work-slider-nav-' + gid).slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: true,
			dots: false,
		});
	});
});

function alignArrows() {
	let imageHeight = 0;
	$('.old-work-slider .old-work-image').each(function() {
		imageHeight = Math.max(imageHeight, $(this).height());
	});
	$('.old-work-slider .slick-prev').css('top', imageHeight / 2);
	$('.old-work-slider .slick-next').css('top', imageHeight / 2);
}

$('.old-work-slider').on('init', function() {
	alignArrows();
});
$(window).resize(function() {
	alignArrows()
});

// Old Work Slider
$(document).ready(function() {
	$('.old-work-slider').slick({
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
		    	}
			}
		]
	});
});

// Navigation
$(document).ready(function() {
  var menuToggle = $("#js-mobile-menu").unbind();
  $("#js-navigation-menu").removeClass("show");

  menuToggle.on("click", function(e) {
    e.preventDefault();
    $("#js-navigation-menu").slideToggle(function() {
      if($("#js-navigation-menu").is(":hidden")) {
        $("#js-navigation-menu").removeAttr("style");
      }
    });
  });
});

// Sliding panel
$(document).ready(function() {
  $('.sliding-panel-button,.sliding-panel-fade-screen,.sliding-panel-close').on('click touchstart',function (e) {
    $('.sliding-panel-content,.sliding-panel-fade-screen').toggleClass('is-visible');
    e.preventDefault();
  });
});



// WEBPACK FOOTER //
// ./src/js/app.js